import React,{useContext} from "react";
import {
  BADGE_COLOR_NAME,
  BADGE_INFO_OBJ,
  CXR_TABS_NAME,
  QC_TABS,
  QC_TABS_NAME,
  REPORTDONESTATUS,
  REPORT_DONE_STATUS,
  REPORTED_TABS_NAME,
  SHOW_EXTERNAL_REPORTING_TO_USER,
  SHOW_SAVED_TAG_TABS,
  TAB_NAME,
  USERTYPES,
} from "../../../../constants/Constants";
import { t } from "i18next";
import { Icon } from "@fluentui/react";

import { statusStyle } from "../../helpers/ConstantStyles";
import userContext from "../../../../context/users/UserContext";
import Resubmitted from "../../../../components/SVGComponents/Resubmitted";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import Moment from "moment";
import themeContext from "../../../../context/theme/ThemeContext";
import { normalizeTimeZone } from "../../../IssuesAndTroubleshooting/helper/helper";
import moment from "moment-timezone";
import { getEnv } from '../../../../helpers/EnvHelper';
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";


const ReportDetailsBadge = (props) => {
    const {roles,userId } = useContext(userContext);
    const { getThemeColor, themeName } = useContext(themeContext);
    const index = props.index;
    // HANDLE THIS FOR PRIOR CHANGES
    //const showForPrior = props.data.row.depth === 0 ? true : false;

    const showForPrior = true;

    let isBvpPlatform = (getEnv("REACT_APP_BVP_PLATFORM") == "true" || getEnv("REACT_APP_BVP_PLATFORM") == true) ? true : false;

    const { getConsistentDateFormat } = useContext(studyReportContext);

    // const getFormattedDate = (inputDate) => {
    //   const parsedDate = Moment(inputDate, 'ddd MMM DD HH:mm:ss z YYYY');
    //   const formattedDate = parsedDate.isValid() ? parsedDate.format('DD-MMM-YY hh:mm A') : 'No date';
    //   return formattedDate;
    // };

    const BACKEND_TZ = getEnv("REACT_APP_BACKEND_TIMEZONE");

const getFormattedDate = (inputDate) => {
  if (!inputDate) return "No Date";

  const rawUserTz = localStorage.getItem("userTimeZone");
  const userTz = normalizeTimeZone(rawUserTz);
  const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const cleanedDate = inputDate.replace(/\s[A-Z]{2,4}\s/, " ");

  // Parse WITHOUT timezone, then apply backend TZ
  const momentDate = moment.tz(
    cleanedDate,
    "ddd MMM DD HH:mm:ss YYYY",
    true,
    BACKEND_TZ
  );

  if (!momentDate.isValid()) {
    console.error("Invalid Java date:", inputDate);
    return "No Date";
  }

  const displayTz = userTz || systemTz;

  return momentDate
    .tz(displayTz)
    .format("DD-MMM-YY hh:mm A");
};


    const getColorValue = (color) => {
      // if(themeName != "light"){
      //   return color;
      // }
      return getThemeColor("primary-color");
    }

    const checkTab = () => {
      return (REPORTED_TABS_NAME.includes(props.tabId) || props.tabId == TAB_NAME.REVIEWASSIGNED 
        || props.tabId == TAB_NAME.REVIEWCOMPLETE || props.tabId == TAB_NAME.EVALUATIONASSIGNED 
        || props.tabId == TAB_NAME.EVALUATIONCOMPLETE || props.tabId == TAB_NAME.PENDING 
        || props.tabId == TAB_NAME.APPROVED || props.tabId == TAB_NAME.REJECTED);
    }
    
    return (<div style={{display:"flex",flexDirection:'column'}}>
     {/* {props.data.row.original.assignmentList[index].reportDoneStatus ===
            REPORT_DONE_STATUS.UNREPORTED && (
            <div
              className="study-list-reportDetails-badges"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              
              <div
                style={{
                  ...statusStyle,
                  backgroundColor: "rgb(129 37 37)",
                  color: "white",
                }}
              >
                &nbsp;UNREPORTED
              </div>
              {props.data.row.original.reportSavedBy == 0 && <div style={{ display: "flex" }}>
                <TooltipHost
                  styles={customToolTipRedTickStyles}
                  content="Report Not Available"
                  id={"tooltip_"}
                >
                  <Icon
                    iconName="Cancel"
                    className="study-list-report-details-badge"
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      fontSize: '12px',
                      lineHeight: "1em",
                    }}
                  ></Icon>
                </TooltipHost>
              </div>}
            </div>
          )} */}

{showForPrior && (props.data.row.original.assignmentList[index].reportDoneStatus ===
              REPORTDONESTATUS.SAVED || (
                //props.data.row.original.reportSavedBy === userId &&
                props.data.row.original.reportSavedBy != 0 &&
                 SHOW_SAVED_TAG_TABS.includes(props.tabId)
                && props.data.row.original.assignmentList[index].reportDoneStatus <=
                REPORT_DONE_STATUS.SAVED
                && props.data.row.original.assignmentList[index].reportDoneStatus !==
                REPORTDONESTATUS.UNREPORTED
                )) && (
              <div
                className="study-list-reportDetails-badges"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  className="study-list-report-details-text"
                  style={{
                    ...statusStyle,
                    backgroundColor: BADGE_INFO_OBJ.SAVED.BACKGROUND,
                    color: BADGE_INFO_OBJ.SAVED.TEXT_COLOR,
                    maxWidth: "180px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "inline-block",
                    lineHeight: "normal",

                  }}
                >
                  {props.data.row.original.assignmentList[index].reportDoneStatus === REPORTDONESTATUS.SAVED
                  && props.data.row.original.studySavedDetails?.savedBy ? <CustomToolTipHost content={`${props.data.row.original.studySavedDetails?.savedBy}`}>{t("info-badge.preliminary-by", { name: props.data.row.original.studySavedDetails?.savedBy })}</CustomToolTipHost> : t("info-badge.preliminary")}
                </div>
                {/* {props.data.row.original.reportSavedBy > 0 && <div style={{ display: "flex" }}>
                <TooltipHost
                  styles={customToolTipWhiteTickStyles}
                  content="Draft Report"
                  id={"tooltip_"}
                >
                  <Icon
                    iconName="Accept"
                    className="study-list-report-details-badge"
                    style={{
                      color: "white",
                      fontWeight: "bold",
                      lineHeight: "1em",
                      fontSize: '12px',
                    }}
                  ></Icon>
                </TooltipHost>
              </div>} */}
              </div>
            )}

            {showForPrior && props.data.row.original.assignmentList[index].colorClassName ===
              BADGE_INFO_OBJ.MORE_THAN_2_HR.COLOR_NAME && (
              <div className="study-list-reportDetails-badges">
                <div
                   className="study-list-report-details-text"
                  style={{
                    ...statusStyle,
                    backgroundColor: BADGE_INFO_OBJ.MORE_THAN_2_HR.BACKGROUND,
                    color: themeName !== "light"?getColorValue(BADGE_INFO_OBJ.MORE_THAN_2_HR.TEXT_COLOR):BADGE_INFO_OBJ.MORE_THAN_2_HR.TEXT_COLOR,
                  }}
                >
                  {isBvpPlatform 
                  && props.data.row.original.assignmentList[index].reportDoneStatus === REPORTDONESTATUS.SAVED 
                  && props.data.row.original.studySavedDetails?.savedOn
                  ? t("info-badge.preliminary-on", { date: getConsistentDateFormat(props.data.row.original.studySavedDetails.savedOn) })
                  : t("info-badge.more-than-2-hr")}
                </div>
              </div>
            )}

            {showForPrior && props.data.row.original.assignmentList[index].colorClassName ===
              BADGE_INFO_OBJ.LESS_THAN_1_HR.COLOR_NAME && (
              <div className="study-list-reportDetails-badges">
                <div
                 className="study-list-report-details-text"
                  style={{
                    ...statusStyle,
                    backgroundColor: BADGE_INFO_OBJ.LESS_THAN_1_HR.BACKGROUND,
                    color: themeName !== "light"?getColorValue(BADGE_INFO_OBJ.LESS_THAN_1_HR.TEXT_COLOR):BADGE_INFO_OBJ.LESS_THAN_1_HR.TEXT_COLOR,
                  }}
                >
                  {isBvpPlatform 
                  && props.data.row.original.assignmentList[index].reportDoneStatus === REPORTDONESTATUS.SAVED 
                  && props.data.row.original.studySavedDetails?.savedOn
                  ? t("info-badge.preliminary-on", { date: getConsistentDateFormat(props.data.row.original.studySavedDetails.savedOn) })
                  : t("info-badge.less-than-1-hr")}
                </div>
              </div>
            )}

            {showForPrior && props.data.row.original.assignmentList[index].colorClassName ===
              BADGE_INFO_OBJ.LESS_THAN_2_HR.COLOR_NAME && (
              <div className="study-list-reportDetails-badges">
                <div
                 className="study-list-report-details-text"
                  style={{
                    ...statusStyle,
                    backgroundColor: BADGE_INFO_OBJ.LESS_THAN_2_HR.BACKGROUND,
                    color: themeName !== "light"?getColorValue(BADGE_INFO_OBJ.LESS_THAN_2_HR.TEXT_COLOR):BADGE_INFO_OBJ.LESS_THAN_2_HR.TEXT_COLOR,
                  }}
                >
                  {isBvpPlatform 
                  && props.data.row.original.assignmentList[index].reportDoneStatus === REPORTDONESTATUS.SAVED
                  && props.data.row.original.studySavedDetails?.savedOn 
                  ? t("info-badge.preliminary-on", { date: getConsistentDateFormat(props.data.row.original.studySavedDetails.savedOn) })
                  : t("info-badge.less-than-2-hr")}
                </div>
              </div>
            )}

            {showForPrior && props.data.row.original.assignmentList[index].colorClassName ===
              BADGE_INFO_OBJ.MORE_THAN_24_HR.COLOR_NAME && (
              <div className="study-list-reportDetails-badges">
                <div
                   className="study-list-report-details-text"
                  style={{
                    ...statusStyle,
                    backgroundColor: BADGE_INFO_OBJ.MORE_THAN_24_HR.BACKGROUND,
                    color: themeName !== "light"?getColorValue(BADGE_INFO_OBJ.MORE_THAN_24_HR.TEXT_COLOR):BADGE_INFO_OBJ.MORE_THAN_24_HR.TEXT_COLOR,
                  }}
                >
                  {isBvpPlatform 
                  && props.data.row.original.assignmentList[index].reportDoneStatus === REPORTDONESTATUS.SAVED 
                  && props.data.row.original.studySavedDetails?.savedOn
                  ? t("info-badge.preliminary-on", { date: getConsistentDateFormat(props.data.row.original.studySavedDetails.savedOn) })
                  : t("info-badge.more-than-24-hr")}
                </div>
              </div>
            )}

            {showForPrior && props.data.row.original.assignmentList[index].reportDoneStatus ===
              REPORT_DONE_STATUS.QCREVIEW && (
              <div className="study-list-reportDetails-badges" style={{display: "flex", flexDirection: "column", alignItems: "flex-start"}}>
                <div
                 className="study-list-report-details-text"
                  style={{
                    ...statusStyle,
                    backgroundColor: BADGE_INFO_OBJ.QC_REVIEW_PENDING.BACKGROUND,
                    color: BADGE_INFO_OBJ.QC_REVIEW_PENDING.TEXT_COLOR,
                  }}
                >
                  {/* <Resubmitted /> */}
                  {t("info-badge.qc-review-pending")}
                </div>
                
              </div>
            )}

            {showForPrior && props.data.row.original.assignmentList[index].reportDoneStatus ===
              REPORT_DONE_STATUS.PRELIMINARY_QC_REVIEW && (
              <div className="study-list-reportDetails-badges" style={{display: "flex", flexDirection: "column", alignItems: "flex-start"}}>
                <div
                 className="study-list-report-details-text"
                  style={{
                    ...statusStyle,
                    backgroundColor: BADGE_INFO_OBJ.QC_REVIEW_PENDING.BACKGROUND,
                    color: BADGE_INFO_OBJ.QC_REVIEW_PENDING.TEXT_COLOR,
                  }}
                >
                  {t("info-badge.preliminary-qc-review-pending")}
                </div>
                
              </div>
            )}

            {showForPrior && props.data.row.original.assignmentList[index].reportDoneStatus ===
              REPORT_DONE_STATUS.QCFIX && (
              <div className="study-list-reportDetails-badges" style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "flex-start",
                }}>
                <div
                 className="study-list-report-details-text"
                  style={{
                    ...statusStyle,
                    backgroundColor: BADGE_INFO_OBJ.QC_FIX_PENDING.BACKGROUND,
                    color: BADGE_INFO_OBJ.QC_FIX_PENDING.TEXT_COLOR,
                  }}
                >
                  {/* <Resubmitted /> */}
                  {t("info-badge.qc-fix-pending")}
                </div>
                
              </div>
            )}

            {showForPrior && props.data.row.original.assignmentList[index].reportDoneStatus ===
              REPORT_DONE_STATUS.PRELIMINARY_QC_FIX && (
              <div className="study-list-reportDetails-badges" style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "flex-start",
                }}>
                <div
                 className="study-list-report-details-text"
                  style={{
                    ...statusStyle,
                    backgroundColor: BADGE_INFO_OBJ.QC_FIX_PENDING.BACKGROUND,
                    color: BADGE_INFO_OBJ.QC_FIX_PENDING.TEXT_COLOR,
                  }}
                >
                  {t("info-badge.preliminary-qc-fix-pending")}
                </div>
                
              </div>
            )}

            {showForPrior && props.data.row.original.assignmentList[index].reportDoneStatus ===
              REPORT_DONE_STATUS.QCVERIFY && (
              <div className="study-list-reportDetails-badges" style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "flex-start",
                }}>
                <div
                 className="study-list-report-details-text"
                  style={{
                    ...statusStyle,
                    backgroundColor: BADGE_INFO_OBJ.QC_VERIFICATION_PENDING.BACKGROUND,
                    color: BADGE_INFO_OBJ.QC_VERIFICATION_PENDING.TEXT_COLOR,
                  }}
                >
                  {/* <Resubmitted /> */}
                  {t("info-badge.qc-verification-pending")}
                </div>
                
              </div>
            )}

            {showForPrior && props.data.row.original.assignmentList[index].reportDoneStatus ===
              REPORT_DONE_STATUS.PRELIMINARY_QC_VERIFY && (
              <div className="study-list-reportDetails-badges" style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "flex-start",
                }}>
                <div
                 className="study-list-report-details-text"
                  style={{
                    ...statusStyle,
                    backgroundColor: BADGE_INFO_OBJ.QC_VERIFICATION_PENDING.BACKGROUND,
                    color: BADGE_INFO_OBJ.QC_VERIFICATION_PENDING.TEXT_COLOR,
                  }}
                >
                  {t("info-badge.preliminary-qc-verification-pending")}
                </div>
                
              </div>
            )}

            {showForPrior && (props.data.row.original.assignmentList[index].reportDoneStatus ===
              REPORT_DONE_STATUS.REPORTED ) && (
                (props.data.row.original.assignmentList[index].reportResubmitStatus > 1 ? false: true) &&  <div
                className="study-list-reportDetails-badges"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "flex-start",
                }}
              >
                <div
                 className="study-list-report-details-text report-badge-wrappable"
                  style={{
                    ...statusStyle,
                    backgroundColor: BADGE_INFO_OBJ.REPORTED.BACKGROUND,
                    color: getColorValue(BADGE_INFO_OBJ.REPORTED.TEXT_COLOR),
                  }}
                >
                  <span className="report-badge-label">{t("info-badge.reported")}:</span>{" "}<span className="report-badge-value">{getFormattedDate(props.data.row.original?.assignmentList[index].reportedDate)}</span>
                </div>
                
                {/* <div style={{ display: "flex",marginRight:'2px' }}>
                <TooltipHost
                  styles={customToolTipGreenTickStyles}
                  content="Report Completed"
                  id={"tooltip_"}
                >
                  <Icon
                    iconName="Accept"
                    className="study-list-report-details-badge"
                    style={{
                      color: "#1eff1ee8",
                      fontWeight: "bold",
                      lineHeight: "1em",
                      fontSize: '12px',
                    }}
                  ></Icon>
                </TooltipHost>
              </div> */}
                {/* { props.data.row.original.raiseAlertAttention && props.data.row.original.raiseAlert != "" &&

              <div style={{ display: "flex" }}>
                <TooltipHost
                  styles={customToolTipRaiseAlertStyles}
                  content={"Raise Alert : "+props.data.row.original.raiseAlert}
                  id={"tooltip_"}
                >
                  <Icon
                    iconName="StatusCircleExclamation"
                    className="study-list-report-details-badge"
                    style={{
                      color: "orange",
                      fontWeight: "bold",
                      lineHeight: "1em",
                      fontSize:'24px',
                    }}
                  ></Icon>
                </TooltipHost>
              </div>} */}
              </div>
            )}

            {showForPrior && props.data.row.original.assignmentList[index].reportResubmitStatus >
              1 && (
              <div
                className="study-list-reportDetails-badges"
                style={{ position: "relative" }}
              >
                <div
                 className="study-list-report-details-text report-badge-wrappable"
                  style={{
                    ...statusStyle,
                    backgroundColor: BADGE_INFO_OBJ.RESUBMITTED.BACKGROUND,
                    color: BADGE_INFO_OBJ.RESUBMITTED.TEXT_COLOR,
                  }}
                >
                  <span className="report-badge-label">{t("info-badge.resubmitted")}:</span>{" "}<span className="report-badge-value">{getFormattedDate(props.data.row.original?.assignmentList[index].reportedDate)}</span>
                </div>
                
                {/* {
                <span
                  style={{ position: "absolute", right: "-12px", top: "-1px" }}
                >
                  <TooltipHost content="Report Modified" id={"tooltip_"}>
                    {isVisible ? (
                      <Icon iconName="Edit" style={{ color: "orange" }} />
                    ) : (
                      <Icon iconName="" />
                    )}
                  </TooltipHost>
                </span>
              } */}
              </div>
            )}

            {props.data.row.original.assignmentList[index].reportDoneStatus !== REPORTDONESTATUS.SAVED && props.data.row.original.studySavedDetails?.savedBy &&
                  <div
                    className="study-list-report-details-text"
                    style={{
                      ...statusStyle,
                      backgroundColor: BADGE_INFO_OBJ.SAVED.BACKGROUND,
                      color: BADGE_INFO_OBJ.SAVED.TEXT_COLOR,
                      maxWidth: "192px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "inline-block",
                      lineHeight: "normal",

                    }}
                  >
                    <CustomToolTipHost content={`${props.data.row.original.studySavedDetails?.savedBy}`}>{t("info-badge.preliminary-by", { name: props.data.row.original.studySavedDetails?.savedBy })}</CustomToolTipHost>
                  </div>
                }

            {/* {props.data.row.original.assignmentList[index].reportDoneStatus === 0 &&
            props.data.row.original.assignmentList[index].reportResubmitStatus ===
              0 && (
              <div className="study-list-reportDetails-badges">
                <div
                  style={{
                    ...statusStyle,
                    backgroundColor: "#FFF9D7",
                    color: "#665000",
                  }}
                >
                  <Pending />
                  &nbsp;PENDING
                </div>
              </div>
            )} */}

            {/* <div style={timeDateStyle}>in 2m 43s</div> */}

            {/* {showForPrior && props.data.row.original.assignmentList[index]
              ?.tatCategoryColorClassName === BADGE_INFO_OBJ.TAT_LESS_THAN_1_HR.COLOR_NAME && (
              <div className="study-list-tat-container">
                <div className="study-list-reportDetails-badges">
                  <div
                   className="study-list-report-details-text"
                    style={{
                      ...statusStyle,
                      backgroundColor: BADGE_INFO_OBJ.TAT_LESS_THAN_1_HR.BACKGROUND,
                      color: getColorValue(BADGE_INFO_OBJ.TAT_LESS_THAN_1_HR.TEXT_COLOR),
                    }}
                  >
                    {t("info-badge.tat-less-than-1-hr")}
                    {checkTab() 
                      ? ` ${props.data.row.original.assignmentList[index]?.tatDisplay} `
                      : ""}
                  </div>
                  {checkTab()  &&
                props.data.row.original.assignmentList[index].tatRating != "" &&
                props.data.row.original.assignmentList[index].tatRating != "0" ? (
                  <div className="study-list-tat-start-badge">
                    <span className="study-list-tat-start-text">
                      {props.data.row.original.assignmentList[index].tatRating}
                    </span>
                    <Icon
                      iconName="FavoriteStarFill"
                      className="study-list-tat-star"
                    />
                  </div>
                ) : (
                  ""
                )}
                </div>

               
              </div>
            )}

            {showForPrior && props.data.row.original.assignmentList[index]
              ?.tatCategoryColorClassName === BADGE_INFO_OBJ.TAT_MORE_THAN_12_HR.COLOR_NAME && (
              <div className="study-list-tat-container">
                <div className="study-list-reportDetails-badges">
                  <div
                   className="study-list-report-details-text"
                    style={{
                      ...statusStyle,
                      backgroundColor: BADGE_INFO_OBJ.TAT_MORE_THAN_12_HR.BACKGROUND,
                      color: getColorValue(BADGE_INFO_OBJ.TAT_MORE_THAN_12_HR.TEXT_COLOR),
                    }}
                  >
                    {t("info-badge.tat-more-than-12-hr")} &nbsp;
                    {checkTab() 
                      ? ` ${props.data.row.original.assignmentList[index]?.tatDisplay} `
                      : ""}
                    {checkTab()  &&
                    props.data.row.original.assignmentList[index].tatRating != "" &&
                    props.data.row.original.assignmentList[index].tatRating !=
                      "0" ? (
                      <Icon
                        iconName="FavoriteStar"
                        className="study-list-tat-star"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                {checkTab()  &&
                props.data.row.original.assignmentList[index].tatRating != "" &&
                props.data.row.original.assignmentList[index].tatRating != "0" ? (
                  <div className="study-list-tat-start-badge">
                    <span className="study-list-tat-start-text">
                      {props.data.row.original.assignmentList[index].tatRating}
                    </span>
                    <Icon
                      iconName="FavoriteStarFill"
                      className="study-list-tat-star"
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
            )}

            {showForPrior && props.data.row.original.assignmentList[index]
              ?.tatCategoryColorClassName === BADGE_INFO_OBJ.TAT_BETWEEN_1_TO_2_HR.COLOR_NAME && (
              <div className="study-list-tat-container">
                <div className="study-list-reportDetails-badges">
                  <div
                   className="study-list-report-details-text"
                    style={{
                      ...statusStyle,
                      backgroundColor: BADGE_INFO_OBJ.TAT_BETWEEN_1_TO_2_HR.BACKGROUND,
                      color: getColorValue(BADGE_INFO_OBJ.TAT_BETWEEN_1_TO_2_HR.TEXT_COLOR),
                    }}
                  >
                    {t("info-badge.tat-between-1-to-2-hr")}
                    {checkTab() 
                      ? ` ${props.data.row.original.assignmentList[index]?.tatDisplay} `
                      : ""}
                  </div>
                  {checkTab()  &&
                props.data.row.original.assignmentList[index].tatRating != "" &&
                props.data.row.original.assignmentList[index].tatRating != "0" ? (
                  <div className="study-list-tat-start-badge">
                    <span className="study-list-tat-start-text">
                      {props.data.row.original.assignmentList[index].tatRating}
                    </span>
                    <Icon
                      iconName="FavoriteStarFill"
                      className="study-list-tat-star"
                    />
                  </div>
                ) : (
                  ""
                )}
                </div>

                
              </div>
            )}

            {showForPrior && props.data.row.original.assignmentList[index]
              ?.tatCategoryColorClassName === BADGE_INFO_OBJ.TAT_BETWEEN_2_TO_3_HR.COLOR_NAME && (
              <div className="study-list-tat-container">
                <div className="study-list-reportDetails-badges">
                  <div
                   className="study-list-report-details-text"
                    style={{
                      ...statusStyle,
                      backgroundColor: BADGE_INFO_OBJ.TAT_BETWEEN_2_TO_3_HR.BACKGROUND,
                      color: getColorValue(BADGE_INFO_OBJ.TAT_BETWEEN_2_TO_3_HR.TEXT_COLOR),
                    }}
                  >
                    {t("info-badge.tat-between-2-to-3-hr")}
                    {checkTab() 
                      ? ` ${props.data.row.original.assignmentList[index]?.tatDisplay} `
                      : ""}
                  </div>
                  {checkTab()  &&
                props.data.row.original.assignmentList[index].tatRating != "" &&
                props.data.row.original.assignmentList[index].tatRating != "0" ? (
                  <div className="study-list-tat-start-badge">
                    <span className="study-list-tat-start-text">
                      {props.data.row.original.assignmentList[index].tatRating}
                    </span>
                    <Icon
                      iconName="FavoriteStarFill"
                      className="study-list-tat-star"
                    />
                  </div>
                ) : (
                  ""
                )}
                </div>

                
              </div>
            )}

            {showForPrior && props.data.row.original.assignmentList[index]
              ?.tatCategoryColorClassName === BADGE_INFO_OBJ.TAT_BETWEEN_3_TO_12_HR.COLOR_NAME && (
              <div className="study-list-tat-container">
                <div className="study-list-reportDetails-badges">
                  <div
                   className="study-list-report-details-text"
                    style={{
                      ...statusStyle,
                      backgroundColor: BADGE_INFO_OBJ.TAT_BETWEEN_3_TO_12_HR.BACKGROUND,
                      color: getColorValue(BADGE_INFO_OBJ.TAT_BETWEEN_3_TO_12_HR.TEXT_COLOR),
                    }}
                  >
                    {t("info-badge.tat-between-3-to-12-hr")}
                    {checkTab() 
                      ? ` ${props.data.row.original.assignmentList[index]?.tatDisplay} `
                      : ""}
                  </div>
                  {checkTab()  &&
                props.data.row.original.assignmentList[index].tatRating != "" &&
                props.data.row.original.assignmentList[index].tatRating != "0" ? (
                  <div className="study-list-tat-start-badge">
                    <span className="study-list-tat-start-text">
                      {props.data.row.original.assignmentList[index].tatRating}
                    </span>
                    <Icon
                      iconName="FavoriteStarFill"
                      className="study-list-tat-star"
                    />
                  </div>
                ) : (
                  ""
                )}
                </div>

                
              </div>
            )} */}
    </div>)
}

export default ReportDetailsBadge;